import { SET_MODE } from "../ActionTypes";


const mode = (state, { payload, type }) => {
    switch (type) {
        case SET_MODE:
            return {
                ...state, 
                mode: {
                    value: payload
                }
            }
    
        default:
            break;
    }
  };
  
  export default mode;
  